import React, { useMemo } from 'react';
import { css } from '@emotion/react';
import { Link } from '@tanstack/react-router';
import { theme } from '@frontend/theme';
import { Accordion, Text } from '@frontend/design-system';
import { UserRole } from '../../utils/constants';
import { checkRbacAccess } from '../../utils/helpers';

interface ExternalPartnerResourcesAccordionProps {
  externalPartnerResources?: any[]; // TODO: Define a proper type for DocumentationLink items
  userRole?: keyof typeof UserRole;
}

const ExternalPartnerResourcesAccordion: React.FC<ExternalPartnerResourcesAccordionProps> = ({
  externalPartnerResources = [],
  userRole,
}) => {
  const filteredLinks = useMemo(() => {
    if (!externalPartnerResources.length) return [];

    return externalPartnerResources.filter((link) =>
      checkRbacAccess({ accessibleByRoles: link.accessibleByRoles, owners: link.owners }, userRole)
    );
  }, [externalPartnerResources, userRole]);

  return (
    <Accordion variant='main' showBoxShadow>
      <Accordion.Item value='external-partner-resources'>
        <Accordion.Header>
          <Text weight='bold'>External Partner Resources</Text>
        </Accordion.Header>
        <Accordion.Body>
          {filteredLinks.length ? (
            <ul css={listStyle}>
              {filteredLinks.map((link) => (
                <li key={link.url}>
                  <Link to={link.url} target='_blank' rel='noopener noreferrer' css={linkStyle}>
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          ) : (
            <Text>No External Partner Resources available for your role.</Text>
          )}
        </Accordion.Body>
      </Accordion.Item>
    </Accordion>
  );
};

export default ExternalPartnerResourcesAccordion;

const listStyle = css`
  padding-left: ${theme.spacing(2)};
`;

const linkStyle = css`
  display: block;
  margin-bottom: ${theme.spacing(2)};
  text-decoration: none;
  &:hover {
    text-decoration: underline;
  }
`;
